import React from 'react';
import { useSelector } from 'umi';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { pcPageConfig } from './pcPageConfig';
import '../index.scss'; 

// 【PC经分】 Techland  DL2 In-Game Revenue 页面专项改造
//  产品要求新建路由处理
const reqParams = '/monetization/inGameRevenueMerge';
const SalesOverview = () => {
  const dataFrame = useSelector((state: any) => state?.dashboard?.currentGame?.data_frame || 'mobile');
  const pageMap: any = {
    pc: pcPageConfig,
  };

  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageMap?.[dataFrame]} />
    </>
  );
};

export default SalesOverview;